import { render, staticRenderFns } from "./InstructionalMatrixView.vue?vue&type=template&id=e86643a0&scoped=true"
import script from "./InstructionalMatrixView.vue?vue&type=script&lang=js"
export * from "./InstructionalMatrixView.vue?vue&type=script&lang=js"
import style0 from "./InstructionalMatrixView.vue?vue&type=style&index=0&id=e86643a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86643a0",
  null
  
)

export default component.exports